module.exports = __webpack_public_path__ + "static/media/cxia-123.7d99e79e.png";